import React, { PureComponent } from 'react';
import classNames from 'classnames';
// import { useTranslation } from 'next-i18next';
// import PropTypes from 'prop-types';
import { basePageWrap } from '../BasePage';
import styles from './WhoWeArePage.module.scss';
import HeroBackground from '../../components/HeroBackground';
import WhoWeAreHero from '../../components/WhoWeAreHero/WhoWeAreHero';
import StreamField from '../../components/StreamField';
import Head from 'next/head';
const WhoWeArePage = ({ gradient, whoWeAreHero = {}, blocks = [], title, seo }) => {
    const classes = classNames(styles['Root'], styles[gradient]);

    const whoWeAreSchema = {
        '@context': 'https://schema.org',
        '@type': 'AboutPage',
        name: title || '',
        description: whoWeAreHero.preamble || '',
        url: seo?.seoOgUrl || '',
    };
    return (
        <>
            <Head>
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify(whoWeAreSchema),
                    }}
                />
            </Head>
            <div className={classes}>
                <HeroBackground />
                <WhoWeAreHero {...whoWeAreHero} />
                <StreamField blocks={blocks} />
            </div>
        </>
    );
};

export default basePageWrap(WhoWeArePage);
